import { createEmptyKetQuaDisplayMn, IKetQua, IKetQuaDisplayMn, IKetQuaXoSo, IMien } from "./types";

export const KetQuaUtils = {
    BuildDisplayKetQua: (ketqua: IKetQua): IKetQuaDisplayMn => {
        let result: IKetQuaDisplayMn = createEmptyKetQuaDisplayMn();
        if (!ketqua || !ketqua.Giais) {
            return result;
        }
        for (let m of ketqua.Giais) {
            const arr = m.Key.split(':')
            const tenGiai = arr[arr.length - 1]
            if (tenGiai.startsWith("0.")) {
                result.G0.push(m.So);
            }
            else if (tenGiai.startsWith("1.")) {
                result.G1.push(m.So);
            }
            else if (tenGiai.startsWith("2.")) {
                result.G2 = [m.So, ...result.G2];
            }
            else if (tenGiai.startsWith("3.")) {
                result.G3 = [m.So, ...result.G3];
            } else if (tenGiai.startsWith("4.")) {
                result.G4 = [m.So, ...result.G4];
            }
            else if (tenGiai.startsWith("5.")) {
                result.G5 = [m.So, ...result.G5];
            }
            else if (tenGiai.startsWith("6.")) {
                result.G6 = [m.So, ...result.G6];
            }
            else if (tenGiai.startsWith("7.")) {
                result.G7 = [m.So, ...result.G7];
            }
            else if (tenGiai.startsWith("8.")) {
                result.G8.push(m.So);
            }
        }

        return result;
    },
}